<template>
  <div v-if="showView">
    <header class="header fixed-top">
      <nav class="navbar navbar-light bg-light">
        <div class="container navbarCont" style="padding: 0">
          <a class="navbar-brand">
            <img src="../assets/logo3.png" class="logo" />
          </a>
          <form class="form-inline searchbox">
            <input
              type="text"
              class="navInput"
              placeholder="请输入关键字"
              placeholder-class="ipt"
            />
            <button class="navbtn" type="submit">
              <img src="../assets/search.png" class="searchico" />
              搜索
            </button>
          </form>
        </div>
      </nav>
      <nav
        class="navbar navbar-expand-lg navbar-light"
        :class="[scrollTop > 100 ? 'shadow' : '']"
        :style="{ background: backgroundColor }"
      >
        <div
          class="container navBox"
          style="display: flex; justify-content: flex-end"
        >
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarsExampleDefault"
            aria-controls="navbarsExampleDefault"
            aria-expanded="false"
            aria-label="Toggle navigation"
            @click="collapseNav"
          >
            <span class="navbar-toggler-icon">
              <img v-if="isCollapse" :src="bgimg1" />
              <img v-else :src="bgimg2" />
            </span>
          </button>

          <div
            class="collapse navbar-collapse"
            id="navbarsExampleDefault"
            style="justify-content: center"
          >
            <ul class="navbar-nav">
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/"
                  >首页</router-link
                >
              </li>
              <li
                class="nav-item"
                :class="[scrollTop > 100 ? 'active2' : 'active']"
              >
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/about"
                  >关于我们</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/product"
                  >产品中心</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/support"
                  >技术支持</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/news"
                  >新闻动态</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/contact"
                  >联系我们</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/hire"
                  >人才招聘</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
    <div class="spacebox"></div>
    <main>
      <!-- 顶部图 -->
      <div class="pictureBox" v-if="picture">
        <img :src="picture.P_IMG" />
      </div>

      <!-- 关于我们 -->
      <div class="aboutWe">
        <div class="toptitle">
          <img src="../assets/zszs.png" />
          <span>关于我们</span>
          <img src="../assets/zszs2.png" />
        </div>
        <!-- 关于我们内容 -->
        <div class="aboutCont">
          <div class="left">
            <p class="name">采航(上海)贸易有限公司</p>
            <p class="line"></p>
            <img src="../assets/company.png" />
          </div>
          <div class="right">
            <p>
              采航(上海)贸易企业有限公司（简称“AST SH”），是VEOLIA Sievers分析仪全国半导体业的总经销商。主要产品是超纯水系统TOC总有机碳分析仪以及UPW Boron超纯水在线硼分析仪，以其独特的设计使得检测范围可以从原水到纯水，覆盖了净化过程中的每个环节，在全球水质检测领域极具影响力!
            </p>
            <p>
              客户分布于全中国，包含TSMC，SMIC，三星，BOE，CSOT，Intel，华虹，华力，积塔，新昇，长江存储，青岛芯恩，天马，维信诺，深超，超视界，华为，比亚迪，晶合，长鑫，鼎泰..等,涵盖所有电子行业指标性客户。
            </p>
            <ul style="margin-bottom: 0">
              <li>
                <i></i>
                AST总部位于台北，成立于1993年，主要从事专业分析仪器销售代理，代理SieversTOC已有超过30年的历史。
              </li>
              <li>
                <i></i>
                AST于2001年设立AST SH办事处，服务大陆地区电子行业客户。
              </li>
              <li>
                <i></i>
                2010年正式成立采航（上海）贸易有限公司，总部位于上海，深耕电子行业水系统TOC在线检测服务，销售台数超过1000台（若包含台湾，超过2000台），有深厚的行业经验技术积累，在各大城市皆有据点提供售后服务，目前有18位资深售后工程师。
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- <div style="width: 100%; height: 32.8125rem"></div> -->
      <!-- 企业文化 -->
      <div class="company">
        <div class="toptitle">
          <img src="../assets/zszs.png" />
          <span>企业文化</span>
          <img src="../assets/zszs2.png" />
        </div>
        <!-- 企业文化内容 -->
        <ul class="intro_ul">
          <li
            v-for="(item, index) in introList"
            :key="index"
            @mouseenter="mouseenter(index)"
            @mouseleave="mouseleave(index)"
          >
            <div :class="[item.isShow ? 'introCont' : 'introCont1']">
              <img :src="item.isShow ? item.imgurl : item.imgurl1" />
              <p class="introword1">{{ item.title }}</p>
              <p class="introword2">{{ item.desc }}</p>
            </div>
          </li>
        </ul>
        <ul class="intro_ul2">
          <li
            v-for="(item, index) in introList"
            :key="index"
            @mouseenter="mouseenter(index)"
            @mouseleave="mouseleave(index)"
          >
            <div :class="[item.isShow ? 'introCont' : 'introCont1']">
              <img :src="item.isShow ? item.imgurl : item.imgurl1" />
              <div class="introwordblock">
                <p class="introword1">{{ item.title }}</p>
                <p class="introword2">{{ item.desc }}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- <div style="width: 100%; height: 36.6875rem"></div> -->
    </main>
    <bottomFooter />
  </div>
</template>

<style>
/* 标题 */
.toptitle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  line-height: 1.875rem;
  font-size: 1.9375rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2e2e2e;
  margin: 4.375rem 0 3.125rem;
}

.toptitle img {
  width: 4.8125rem;
  height: 0.875rem;
}

.toptitle span {
  margin: 0 1.3125rem;
}

/* 关于我们 */
.aboutWe,
.company {
  width: 100%;
  max-width: 1920px;
  overflow: hidden;
  margin: 0 auto;
}

.aboutWe {
  background: url(../assets/zs1.png) no-repeat left;
  background-size: 100% 100%;
}

.company {
  background: url(../assets/zs2.png) no-repeat left;
  background-size: 100% 100%;
}

.aboutCont {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  /* width: 70%;
  margin-left: 15%; */
  width: 63%;
  margin-left: 19%;
  box-sizing: 0;
}

.aboutCont .left {
  display: flex;
  flex-direction: column;
  max-width: 400px;
  width: 100%;
}

.aboutCont .name {
  line-height: 2.1875rem;
  font-size: 2.125rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  text-align: left;
  color: #333333;
  margin-bottom: 0;
}

.aboutCont .line {
  width: 5.75rem;
  height: 0.25rem;
  background: #020e62;
  margin: 1.0625rem 0 1.1875rem;
}

.aboutCont img {
  width: 100%;
  max-width: 25rem;
  max-height: 14.25rem;
  height: auto;
  object-fit: cover;
}

.aboutCont .right {
  line-height: 1.4375rem;
  font-size: 1rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  text-align: left;
  color: #333333;
  padding-left: 2.1875rem;
}

.aboutCont .right p,
.aboutCont .right ul li {
  margin-bottom: 1.1875rem;
}

.aboutCont .right ul li {
  position: relative;
  padding-left: 0.875rem;
}

.aboutCont .right ul li i {
  position: absolute;
  top: 0.875rem;
  left: 0;
  display: inline-block;
  width: 0.3125rem;
  height: 0.3125rem;
  background: #333333;
  border-radius: 50%;
  margin-right: 0.3rem;
}

.aboutCont .right ul li:last-of-type {
  margin-bottom: 0;
}

.aboutCont .right:hover {
  color: #020e62;
}
/* 企业文化 */

.intro_ul {
  display: flex;
  justify-content: space-between;
  /* width: 70%; */
  width: 63%;
  height: 19.5rem;
  background: #ffffff;
  box-shadow: 0rem 0.5625rem 0.8125rem 0rem rgba(0, 0, 0, 0.05);
  margin: 0 18% 3.75rem 19%;
}

.intro_ul li {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: calc((100% - 3.75rem) / 3);
  height: 100%;
}

.intro_ul li .introCont,
.intro_ul li .introCont1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 1.5rem 1.125rem 0;
  border: 1px solid #ebebeb;
  box-sizing: border-box;
}

.intro_ul li .introCont {
  background: #ffffff;
}

.intro_ul li .introCont1 {
  background: #020e62;
}

.intro_ul2 {
  display: none;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  padding: 2%;
  background: #ffffff;
  box-sizing: border-box;
}

.intro_ul2 li {
  position: relative;
  width: 100%;
  height: 5.5rem;
  border: 1px solid #ebebeb;
  margin-bottom: 0.625rem;
}

.intro_ul2 li:last-of-type {
  margin-bottom: 0;
}

.intro_ul2 li .introCont,
.intro_ul2 li .introCont1 {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.intro_ul2 li .introCont {
  background: #ffffff;
}

.intro_ul2 li .introCont1 {
  background: #020e62;
}

.intro_ul li img {
  width: 5.875rem;
  height: 5.875rem;
  margin-bottom: 0.5rem;
}

.intro_ul2 li img {
  width: 3.75rem;
  height: 3.75rem;
  margin: 0.375rem 0.625rem 0.375rem 0.375rem;
}

.introwordblock {
  width: calc(100% - 5.625rem);
}

.intro_ul .introCont .introword1 {
  line-height: 1.6875rem;
  font-size: 1.6875rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  margin-bottom: 1.625rem;
}

.intro_ul .introCont1 .introword1 {
  line-height: 1.6875rem;
  font-size: 1.6875rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  margin-bottom: 1.625rem;
}

.intro_ul .introCont .introword2 {
  line-height: 1.9375rem;
  font-size: 1.3125rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

.intro_ul .introCont1 .introword2 {
  line-height: 1.9375rem;
  font-size: 1.3125rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.intro_ul2 .introCont .introword1 {
  line-height: 1rem;
  font-size: 1rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  text-align: left;
  color: #2a2a2a;
  margin-bottom: 0.625rem;
}

.intro_ul2 .introCont1 .introword1 {
  line-height: 1rem;
  font-size: 1rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  text-align: left;
  color: #ffffff;
  margin-bottom: 0.625rem;
}

.intro_ul2 .introCont .introword2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 1.0625rem;
  font-size: 0.8125rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  text-align: left;
  color: #757575;
}

.intro_ul2 .introCont1 .introword2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 1.0625rem;
  font-size: 0.8125rem;
  font-family: Microsoft YaHei;
  font-weight: 500;
  text-align: left;
  color: #ffffff;
}

@media (min-width: 1200px) and (max-width: 1410px) {
  .intro_ul,
  .aboutCont {
    width: 70% !important;
    margin-left: 15% !important;
  }

  .aboutCont .name {
    line-height: 2rem;
    font-size: 1.8rem;
  }

  .aboutCont .right p,
  .aboutCont .right ul li {
    margin-bottom: 1rem;
  }

  .intro_ul li {
    width: calc((100% - 3rem) / 3);
  }

  .intro_ul .introCont .introword1,
  .intro_ul .introCont1 .introword1 {
    line-height: 1.5625rem;
    font-size: 1.5625rem;
  }

  .intro_ul .introCont .introword2,
  .intro_ul .introCont1 .introword2 {
    line-height: 1.8125rem;
    font-size: 1.1875rem;
  }
}

@media (min-width: 980px) and (max-width: 1199px) {
  .intro_ul,
  .aboutCont {
    width: 80% !important;
    margin-left: 10% !important;
  }

  .aboutCont .name {
    line-height: 2rem;
    font-size: 1.6rem;
  }

  .aboutCont .right {
    line-height: 1.2rem;
    font-size: 1rem;
  }

  .aboutCont .right p,
  .aboutCont .right ul li {
    margin-bottom: 0.75rem;
  }

  .intro_ul li {
    width: calc((100% - 2.875rem) / 3);
  }

  .intro_ul .introCont .introword1,
  .intro_ul .introCont1 .introword1 {
    line-height: 1.5rem;
    font-size: 1.5rem;
  }

  .intro_ul .introCont .introword2,
  .intro_ul .introCont1 .introword2 {
    line-height: 1.625rem;
    font-size: 1.2rem;
  }
}

@media (min-width: 901px) and (max-width: 979px) {
  .intro_ul,
  .aboutCont {
    width: 80% !important;
    margin-left: 10% !important;
  }

  .aboutCont .name {
    line-height: 2rem;
    font-size: 1.4rem;
  }

  .aboutCont .right {
    line-height: 1.2rem;
    font-size: 1rem;
  }

  .aboutCont .right p,
  .aboutCont .right ul li {
    margin-bottom: 0.75rem;
  }

  .intro_ul li {
    width: calc((100% - 2.5rem) / 3);
  }

  .intro_ul .introCont .introword1,
  .intro_ul .introCont1 .introword1 {
    line-height: 1.5rem;
    font-size: 1.5rem;
  }

  .intro_ul .introCont .introword2,
  .intro_ul .introCont1 .introword2 {
    line-height: 1.5rem;
    font-size: 1.1rem;
  }
}

@media (min-width: 769px) and (max-width: 900px) {
  .intro_ul,
  .aboutCont {
    width: 90% !important;
    margin-left: 5% !important;
  }

  .aboutCont .name {
    line-height: 2rem;
    font-size: 1.4rem;
  }

  .aboutCont .right {
    line-height: 1.2rem;
    font-size: 1rem;
  }

  .aboutCont .right p,
  .aboutCont .right ul li {
    margin-bottom: 0.625rem;
  }

  .intro_ul {
    height: 18rem;
  }

  .intro_ul li {
    width: calc((100% - 2rem) / 3);
  }

  .intro_ul li .introCont, 
  .intro_ul li .introCont1 {
    padding: 1.5rem 1rem 0;
  }

  .intro_ul .introCont .introword1,
  .intro_ul .introCont1 .introword1 {
    line-height: 1.5rem;
    font-size: 1.5rem;
  }

  .intro_ul .introCont .introword2,
  .intro_ul .introCont1 .introword2 {
    line-height: 1.5rem;
    font-size: 1.1rem;
  }
}

@media (min-width: 500px) and (max-width: 768px) {
  .intro_ul,
  .aboutCont {
    width: 90% !important;
    margin-left: 5% !important;
  }

  .aboutCont {
    flex-direction: column;
  }

  .aboutCont .left,
  .aboutCont .right {
    width: 100%;
  }

  .aboutCont .right {
    line-height: 1.2rem;
    font-size: 1rem;
    margin-top: 0.9375rem;
    padding-left: 0;
  }

  .aboutCont .right p,
  .aboutCont .right ul li {
    margin-bottom: 0.625rem;
  }

  .aboutCont .line {
    margin: 1rem 0 1.1rem;
  }

  .aboutCont .name {
    line-height: 2rem;
    font-size: 1.4rem;
  }

  .intro_ul {
    height: 17rem;
  }

  .intro_ul li {
    width: calc((100% - 1.5rem) / 3);
  }

  .intro_ul li img {
    width: 5rem;
    height: 5rem;
    margin-bottom: 0.5rem;
  }

  .intro_ul li .introCont, 
  .intro_ul li .introCont1 {
    padding: 1.5rem .625rem 0;
  }

  .intro_ul .introCont .introword1,
  .intro_ul .introCont1 .introword1 {
    line-height: 1.3rem;
    font-size: 1.3rem;
    margin-bottom: 1.4rem;
  }

  .intro_ul .introCont .introword2,
  .intro_ul .introCont1 .introword2 {
    line-height: 1.25rem;
    font-size: 1.0625rem;
  }
}

@media (min-width: 0px) and (max-width: 499px) {
  .intro_ul {
    display: none;
  }

  .intro_ul2 {
    display: flex;
  }

  .aboutCont {
    flex-direction: column;
    width: 96% !important;
    margin: 0 2% !important;
  }

  .aboutCont .left,
  .aboutCont .right {
    width: 100%;
  }

  .aboutCont .right {
    line-height: 1.2rem;
    font-size: 0.9rem;
    margin-top: 0.9375rem;
    padding-left: 0;
  }

  .aboutCont .right p,
  .aboutCont .right ul li {
    margin-bottom: 0.5rem;
  }

  .aboutCont .line {
    margin: 0.6rem 0 0.6rem;
  }

  .aboutCont .name {
    line-height: 1.8rem;
    font-size: 1.2rem;
  }
}
</style>

<script>
import bottomFooter from "@/components/bottomFooter.vue";
import { getBackground } from "../api/interface"; // 引入接口
export default {
  name: "AboutView",
  components: {
    bottomFooter,
  },
  data() {
    return {
      backgroundColor: "",
      fontColor: "",
      scrollTop: 0,
      picture: null,
      showView: false,
      introList: [
        {
          imgurl: require("../assets/a1.png"),
          imgurl1: require("../assets/a11.png"),
          title: "采航的理念",
          desc: "永续经验!不断学习!提供最佳产品!提供最完善的服务!",
          isShow: true, //是否显示introCont
        },
        {
          imgurl: require("../assets/a2.png"),
          imgurl1: require("../assets/a22.png"),
          title: "采航的人员",
          desc: "亲切、负责、认真!工程技术人员多数人拥有10年以上专业实务上的经验!",
          isShow: true, //是否显示introCont
        },
        {
          imgurl: require("../assets/a3.png"),
          imgurl1: require("../assets/a33.png"),
          title: "采航的服务",
          desc: "在业界具有良好信誉",
          isShow: true, //是否显示introCont
        },
      ],
      isCollapse: true, //是否折叠导航条
      bgimg1: require("../assets/collapse.png"),
      bgimg2: require("../assets/close1.png"),
    };
  },

  created() {
    this.getImg();
  },

  mounted() {
    //首先，在mounted钩子window添加一个滚动滚动监听事件
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    //然后在方法中，添加这个handleScroll方法来获取滚动的位置
    handleScroll() {
      // let scrollTop =
      //   window.pageYOffset ||
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop;
      let scrollTop = document.documentElement.scrollTop;

      console.log("scrollTop", scrollTop);

      //设置页面滚动时目录导航栏的背景颜色
      if (scrollTop > 100) {
        this.$set(this, "scrollTop", scrollTop);
        this.$set(this, "backgroundColor", "#fff");
        this.$set(this, "fontColor", "#000000!important");
      } else {
        this.$set(this, "scrollTop", scrollTop);
        this.$set(this, "backgroundColor", "rgba(0, 0, 0, 0.1)");
        this.$set(this, "fontColor", "#ffffff");
      }
      console.log(this.fontColor);
    },

    // 折叠导航栏
    collapseNav() {
      const that = this;
      that.$set(that, "isCollapse", !that.isCollapse);
    },

    // 获取图片数据
    async getImg() {
      const that = this;
      await getBackground({ P_INFO: "about-us" }).then((res) => {
        console.log(res);
        if (res.state == "success") {
          that.$set(that, "picture", res.picture);
          if (that.picture != null) {
            that.$set(that, "showView", true);
          }
        }
      });
    },

    mouseenter(id) {
      let introList = this.introList;
      introList[id].isShow = false;
      this.$set(this, "introList", introList);
    },

    mouseleave(id) {
      let introList = this.introList;
      introList[id].isShow = true;
      this.$set(this, "introList", introList);
    },
  },

  //由于是在整个window中添加的事件，所以要在页面离开时摧毁掉，否则会报错
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
